import moment from "moment"
import React, { useState } from "react"
import { Col, Container, Row, Table } from "react-bootstrap"
import toast from "react-hot-toast"
import { useNavigate, useParams } from "react-router-dom"
import cleanLogo from "../../Assets/Images/Login/transparent_bg.png"
import signature from "../../Assets/Images/signature.png"
import Navbar from "../../Components/Navbar/Navbar"
import PaymentTable from "./PaymentTable"
import { getSingleSalesInvoice } from "../../Helpers/apiCalls/franchiseeApi"
import { getItem } from "../../Helpers/apiCalls/itemsApi"
import {
  getInvoice,
  getPaymentHistory,
} from "../../Helpers/apiCalls/Purchases/purchaseInvoiceApi"
import { getSupplier } from "../../Helpers/apiCalls/suppliersApi"
import {
  dateFormat,
  formatDate,
  getName,
  getTodayDateISO,
  isAdmin,
  numberFormat,
  refreshPage,
  toastStyle,
  TokenExpiry,
} from "../../Helpers/Utils/Common"
import "./SalesInvoice.css"
import Moment from "moment"

export default function PrintSalesInvoice() {
  const { franchisee_sale_id } = useParams() // franchisee_sale_id
  let navigate = useNavigate()

  const [inactive, setInactive] = useState(true)
  const [salesInvoice, setSalesInvoice] = useState([])
  const [items, setItems] = useState([])
  const [paymentInfo, setPaymentInfo] = useState([])

  async function fetchSalesInvoice() {
    setSalesInvoice({})
    setPaymentInfo([])
    setItems([])

    const response = await getSingleSalesInvoice(franchisee_sale_id)

    if (response.error) {
      TokenExpiry(response)
    } else {
      var details = response.data.data[0]
      details.subtotal = response.data.data[0].franchisee_sale_items
        .map((item) => item.subtotal)
        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
      // if (details.payment_status === "closed_bill") {
      //     details.fs_status = "Invoiced";
      // } else if (
      //     details.payment_status === "open_bill" &&
      //     (details.paid_amount !== "0.00" ||
      //         details.franchisee_sale_payments.length !== 0)
      // ) {
      //     details.fs_status = "Invoiced";
      // };
      setSalesInvoice(details)
      setItems(details.franchisee_sale_items)
      //

      var payment = details.franchisee_sale_payments.map((data) => {
        if (data.paid_amount !== "0.00") {
          var info = data
          info.paid_amount = numberFormat(data.paid_amount)
          info.deposit_amount = response.data.deposit_amounts[info.payment_no]
            ? numberFormat(response.data.deposit_amounts[info.payment_no])
            : ""
          if (data.payment_type === "check") {
            info.payment_type = data.payment_type + "-" + data.cheque_number
          }
          setPaymentInfo((prev) => [...prev, info])
          return info
        }
      })
    }
  }

  async function handlePrint() {
    toast.loading("Printing sales invoice...", { style: toastStyle() })
    setTimeout(() => {
      toast.dismiss()
      Print()
    }, 1000)
  }
  async function handlePrintWarehouse() {
    toast.loading("Printing sales invoice for warehouse...", {
      style: toastStyle(),
    })
    setTimeout(() => {
      toast.dismiss()
      PrintWarehouse()
    }, 1000)
  }

  function renderTable() {
    return (
      <Table className="align-middle">
        <thead>
          <tr>
            <th>Item</th>
            <th className="text-end">Quantity</th>
            <th>Unit</th>
            <th className="text-end">Price</th>
            <th className="text-end">Discount</th>
            <th className="text-end">Amount</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => {
            return (
              <tr className="req-table-w-border-bottom">
                <td className="req-table-w-border-sides">{item.item_name}</td>
                <td className="text-end req-table-w-border-sides">
                  {numberFormat(item.qty)}
                </td>
                <td className=" req-table-w-border-sides">{item.unit}</td>
                <td className="text-end req-table-w-border-sides">
                  {numberFormat(item.price)}
                </td>
                <td className="text-end req-table-w-border-sides">
                  {numberFormat(item.discount)}
                </td>
                <td className="text-end req-table-w-border-sides">
                  {numberFormat(item.subtotal)}
                </td>
                <td className="text-end req-table-w-border-sides"></td>
              </tr>
            )
          })}
          <tr>
            <td colSpan={7}>
              <div>{/* <hr /> */}</div>
            </td>
          </tr>
          <tr>
            <td colSpan={5}></td>
            <td className="left">Subtotal</td>
            <td className="right">
              {salesInvoice.subtotal
                ? numberFormat(salesInvoice.subtotal)
                : "0.00"}
            </td>
          </tr>
          <tr>
            <td colSpan={5}></td>
            <td className="left">Service Fee</td>
            <td className="right">
              {salesInvoice.service_fee
                ? numberFormat(salesInvoice.service_fee)
                : "0.00"}
            </td>
          </tr>
          <tr>
            <td colSpan={5}></td>
            <td className="left">Delivery Fee</td>
            <td className="right">
              {salesInvoice.delivery_fee
                ? numberFormat(salesInvoice.delivery_fee)
                : "0.00"}
            </td>
          </tr>
          <tr>
            <td colSpan={5}></td>
            <td className="left">GRAND TOTAL</td>
            <td className="right">
              {salesInvoice.grand_total
                ? numberFormat(salesInvoice.grand_total)
                : "0.00"}
            </td>
          </tr>
        </tbody>
      </Table>
    )
  }

  function renderWarehouseTable() {
    return (
      <Table className="align-middle">
        <thead>
          <tr>
            <th>Transfer Qty</th>
            <th>Item</th>
            <th>Unit</th>
            <th className="text-end">Quantity</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => {
            return (
              <tr className="req-table-w-border-bottom">
                <td className="req-table-w-border-sides"></td>
                <td className="req-table-w-border-sides">{item.item_name}</td>
                <td className="text-lowercase req-table-w-border-sides">
                  {item.unit}
                </td>
                <td className="text-end req-table-w-border-sides">
                  {numberFormat(item.qty)}
                </td>
                <td className="req-table-w-border-sides"></td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }
  function PrintWarehouse() {
    let printContents = document.getElementById(
      "printabledivwarehouse"
    ).innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }

  //
  React.useEffect(() => {
    fetchSalesInvoice()
  }, [])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"FRANCHISE"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <div className="print-container px-3 py-2" id="printablediv">
          <div
            className={
              salesInvoice.fs_status === "invoiced"
                ? "text-end print-header d-flex flex-column"
                : "text-start print-header d-flex flex-column"
            }
          >
            {salesInvoice.fs_status === "invoiced" ? (
              <span>FRANCHISE INVOICE NO. {franchisee_sale_id}</span>
            ) : salesInvoice.fs_status === "quoted" ? (
              <span>ORDER QUOTATION NO. {franchisee_sale_id}</span>
            ) : (
              <span>ORDER REQUEST NO. {franchisee_sale_id}</span>
            )}
            <span className="text-uppercase">
              {moment(salesInvoice.added_on).format("MMMM DD, yyyy")}
            </span>
          </div>
          <div className="d-flex justify-content-center py-1">
            <img src={cleanLogo} className="print-logo" />
          </div>

          {/* content */}
          <div className="mt-5 justify-content-start">
            <Row className="d-flex align-items-start ms-5">
              <Col>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Franchisee:
                  </Col>
                  <Col xs={7} className="print-data">
                    {salesInvoice.franchisee_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Buyer Branch:
                  </Col>
                  <Col xs={7} className="print-data">
                    {salesInvoice.buyer_branch_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Released From:
                  </Col>
                  <Col xs={7} className="print-data">
                    {salesInvoice.seller_branch_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Released By:
                  </Col>
                  <Col xs={7} className="print-data">
                    {salesInvoice.sales_staff_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Invoice Status:
                  </Col>
                  <Col xs={7} className="print-data">
                    {salesInvoice.fs_status}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Ship Via:
                  </Col>
                  <Col xs={7} className="print-data">
                    {salesInvoice.ship_via === "pick_up"
                      ? "Pick Up"
                      : salesInvoice.ship_via}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Delivery Date:
                  </Col>
                  <Col xs={7} className="print-data">
                    {dateFormat(salesInvoice.delivery_date)}
                  </Col>
                </div>
              </Col>
              <Col>
                {salesInvoice.franchisee_sale_payments?.length !== 0 ? (
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Franchisee Invoice No.:
                    </Col>
                    <Col xs={7} className="print-data">
                      {salesInvoice.id}
                    </Col>
                  </div>
                ) : (
                  ""
                )}
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Franchisee Order Request No.:
                  </Col>
                  <Col xs={7} className="print-data">
                    {salesInvoice.id}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Transfer Slip No.:
                  </Col>
                  <Col xs={7} className="print-data">
                    {salesInvoice.transfer_slip_no}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Order Request Date:
                  </Col>
                  <Col xs={7} className="print-data">
                    {dateFormat(salesInvoice.order_request_date)}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Sales Date:
                  </Col>
                  <Col xs={7} className="print-data">
                    {dateFormat(salesInvoice.sales_date)}
                  </Col>
                </div>
              </Col>
            </Row>
            <div className="d-flex mt-2 justify-content-evenly">
              <div className="print-table mt-3 mx-2">{renderTable()}</div>
            </div>

            <Row className="mt-2 ms-5">
              <span className="print-footer">{salesInvoice.remarks}</span>
            </Row>
            <Row className="mt-2">
              <Col
                xs={6}
                className="print-sig justify-content-center d-flex"
              ></Col>
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <img src={signature} className="print-logo" />
              </Col>
            </Row>
            <Row className="mt-2 mb-5">
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <Row className="print-sig justify-content-center gotham">
                  {salesInvoice.added_by_name}
                  <div className="margin-underline"></div>
                  Prepared by
                </Row>
              </Col>
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <Row className="print-sig justify-content-center gotham">
                  APPROVERS NAME
                  <div className="margin-underline"></div>
                  Approved by
                </Row>
              </Col>
            </Row>
            <Row className="mt-5 justify-content-center">
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <Row className="print-sig justify-content-center gotham">
                  {salesInvoice.client}
                  <div className="margin-underline"></div>
                  Noted by (Client)
                </Row>
              </Col>
            </Row>
            {/* <div className="print-signatures">
                            <div className="d-flex print-sig align-items-center gotham justify-content-end flex-column">
                                <span className="text-center text-uppercase fw-bold">
                                    {salesInvoice?.added_by_name}
                                </span>
                            </div>
                            <div className="d-flex print-sig align-items-center gotham justify-content-center flex-column">
                                <img src={signature} className="print-logo" />
                                <span className="text-center text-uppercase fw-bold">
                                    APPROVERS NAME
                                </span>
                            </div>
                        </div>
                        <div className="print-signatories pb-2">
                            <span>Prepared by</span>
                            <span>Approved by</span>
                        </div>
                        <div className="print-signatures">
                            <span className="text-center text-uppercase gotham fw-bold">
                                {salesInvoice.client}
                            </span>
                        </div>
                        <div className="print-signatories pb-4 mb-4">
                            <span>Noted by (Client)</span>
                        </div> */}
          </div>
        </div>

        <Container
          fluid
          className="PI-payment-info-wrapper mt-5 py-3 px-3 edit-form"
        >
          <h5 className="PI-payment-info">PAYMENT HISTORY</h5>
          <div className="justify-content-center">
            <PaymentTable
              tableHeaders={[
                "PMT DATE",
                "INV NO.",
                "TYPE",
                "PAID AMT",
                "DEPOSIT AMT",
                "DEPOSIT DATE",
                "DEPOSITED TO",
                "REMARKS",
              ]}
              headerSelector={[
                "payment_date",
                "invoice_no",
                "payment_type",
                "paid_amount",
                "deposit_amount",
                "deposit_date",
                "to_bank_name",
                "remarks",
              ]}
              tableData={paymentInfo}
            />
          </div>
        </Container>

        {/* footer */}
        <div className="d-flex justify-content-end my-4 pb-5 d-flex-responsive">
          <button
            className="button-secondary me-3"
            onClick={() => navigate("/salesinvoice")}
          >
            Close
          </button>
          {salesInvoice.payment_status === "open_bill" && isAdmin() ? (
            <button
              className="button-tertiary me-3"
              onClick={() =>
                navigate("/salesinvoice/edit/" + franchisee_sale_id)
              }
            >
              Edit
            </button>
          ) : (
            ""
          )}
          {salesInvoice.fs_status === "processing" && (
            <button
              className="button-secondary me-3"
              onClick={handlePrintWarehouse}
            >
              Print Warehouse
            </button>
          )}
          <button className="button-primary" onClick={handlePrint}>
            Print
          </button>
        </div>
      </div>
      <div
        className="print-container px-3 py-2 display-none"
        id="printabledivwarehouse"
      >
        <div
          className={
            salesInvoice.fs_status === "invoiced"
              ? "text-end print-header d-flex flex-column"
              : "text-start print-header d-flex flex-column"
          }
        >
          {salesInvoice.fs_status === "invoiced" ? (
            <span>FRANCHISE INVOICE NO. {franchisee_sale_id}</span>
          ) : salesInvoice.fs_status === "quoted" ? (
            <span>ORDER QUOTATION NO. {franchisee_sale_id}</span>
          ) : (
            <span>ORDER REQUEST NO. {franchisee_sale_id}</span>
          )}
          <span className="text-uppercase">
            {moment(salesInvoice.added_on).format("MMMM DD, yyyy")}
          </span>
        </div>
        <div className="d-flex justify-content-center py-1">
          <img src={cleanLogo} className="print-logo" />
        </div>

        {/* content */}
        <div className="mt-5 justify-content-start">
          <Row className="d-flex align-items-start ms-5">
            <Col>
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Franchisee:
                </Col>
                <Col xs={7} className="print-data">
                  {salesInvoice.franchisee_name}
                </Col>
              </div>
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Buyer Branch:
                </Col>
                <Col xs={7} className="print-data">
                  {salesInvoice.buyer_branch_name}
                </Col>
              </div>
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Released From:
                </Col>
                <Col xs={7} className="print-data">
                  {salesInvoice.seller_branch_name}
                </Col>
              </div>
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Released By:
                </Col>
                <Col xs={7} className="print-data">
                  {salesInvoice.sales_staff_name}
                </Col>
              </div>
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Invoice Status:
                </Col>
                <Col xs={7} className="print-data">
                  {salesInvoice.fs_status}
                </Col>
              </div>
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Ship Via:
                </Col>
                <Col xs={7} className="print-data">
                  {salesInvoice.ship_via === "pick_up"
                    ? "Pick Up"
                    : salesInvoice.ship_via}
                </Col>
              </div>
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Delivery Date:
                </Col>
                <Col xs={7} className="print-data">
                  {dateFormat(salesInvoice.delivery_date)}
                </Col>
              </div>
            </Col>
            <Col>
              {salesInvoice.franchisee_sale_payments?.length !== 0 ? (
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Franchisee Invoice No.:
                  </Col>
                  <Col xs={7} className="print-data">
                    {salesInvoice.id}
                  </Col>
                </div>
              ) : (
                ""
              )}
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Franchisee Order Request No.:
                </Col>
                <Col xs={7} className="print-data">
                  {salesInvoice.id}
                </Col>
              </div>
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Transfer Slip No.:
                </Col>
                <Col xs={7} className="print-data">
                  {salesInvoice.transfer_slip_no}
                </Col>
              </div>
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Order Request Date:
                </Col>
                <Col xs={7} className="print-data">
                  {dateFormat(salesInvoice.order_request_date)}
                </Col>
              </div>
              <div className="d-flex my-2 align-items-center">
                <Col xs={4} className="print-label">
                  Sales Date:
                </Col>
                <Col xs={7} className="print-data">
                  {dateFormat(salesInvoice.sales_date)}
                </Col>
              </div>
            </Col>
          </Row>
          <div className="d-flex mt-2 justify-content-evenly">
            {/* table */}
            <div className="print-table mt-3 mx-2">
              {renderWarehouseTable()}
            </div>
          </div>

          <Row className="mt-2 ms-5">
            <span className="print-footer">{salesInvoice.remarks}</span>
          </Row>
          <Row className="mt-2">
            <Col
              xs={6}
              className="print-sig justify-content-center d-flex"
            ></Col>
            <Col xs={6} className="print-sig justify-content-center d-flex">
              <img src={signature} className="print-logo" />
            </Col>
          </Row>
          <Row className="mt-2 mb-5">
            <Col xs={6} className="print-sig justify-content-center d-flex">
              <Row className="print-sig justify-content-center gotham">
                {salesInvoice.added_by_name}
                <div className="margin-underline"></div>
                Prepared by
              </Row>
            </Col>
            <Col xs={6} className="print-sig justify-content-center d-flex">
              <Row className="print-sig justify-content-center gotham">
                APPROVERS NAME
                <div className="margin-underline"></div>
                Approved by
              </Row>
            </Col>
          </Row>
          <Row className="mt-5 justify-content-center">
            <Col xs={6} className="print-sig justify-content-center d-flex">
              <Row className="print-sig justify-content-center gotham">
                {salesInvoice.client}
                <div className="margin-underline"></div>
                Noted by (Client)
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}
